/* global axios */
import ApiClient from '../ApiClient';

class ArrowsAiAssistantsAPI extends ApiClient {
  constructor() {
    super('arrows_ai/assistants', { accountScoped: true });
  }

  connectInbox(assistantId, inboxId) {
    return axios.post(`${this.url}/${assistantId}/inboxes`, {
      inbox_id: inboxId,
    });
  }

  disconnectInbox(assistantId, inboxId) {
    return axios.delete(`${this.url}/${assistantId}/inboxes/${inboxId}`);
  }

  sendPlaygroundMessage(assistantId, messages) {
    return axios.post(`${this.url}/${assistantId}/playground_messages`, {
      messages,
    });
  }

  getMetrics(assistantId) {
    return axios.get(`${this.url}/${assistantId}/metrics`);
  }
}

export default new ArrowsAiAssistantsAPI();
